var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LinerNotes"},[_c('ul',[_vm._l((_vm.notes),function(item,index){return [_c('li',{key:index},[_c('h3',[_vm._v(_vm._s(((index+1) + "."))+" "+_vm._s(item.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.text))])])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-710a8199","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinerNotes.vue
// module id = null
// module chunks = 